<template>    
    <BaseModal
        :id="'static'"
        :title="title"
        :message="message"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <LocalCentralButtons
                    :save_view="true"
                    :modal_name="'static'"
                    @saveView="save_and_view($event)"
                />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources        from    './form_resources'
import FormDynamic          from    '@/components/FormDynamic.vue'
import Breadcrumb           from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal            from    '@/components/BaseModal'
import LocalCentralButtons  from    '@/components/QcComponent/Inspection/LocalCentralButtons'


export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        LocalCentralButtons,
    },

    data(){
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format_lite,
            form_backup:    {...FormResources.form_data},
            message: 'Use this form to log new productivity',
        }
    },

    methods:
    {
        save_and_view(event) {
            this.$emit('saveView', event)
        },
    },

    mounted(){
    }
    
}
</script>